import ProgressGoalSettingBehaviourChangeGoals from 'dashboard/templates/views/Patient/Progress/ProgressGoalSettingBehaviourChangeGoals';

export default {
  path: 'behaviour-change-goals',
  name: 'ProgressGoalSettingBehaviourChangeGoals',
  component: ProgressGoalSettingBehaviourChangeGoals,
  meta: {
    // title: 'Patient Record - Progress - Goal Setting - Behaviour change goals',
    // title: t => `${t('patient.patientRecord')} - ${t('journeyProgress.progress')} - ${t('journeyProgress.goalSetting')} - ${t('startMovingLevel4.choicesPractices.goals', 'content')}`,
    // title: 'Journey - Progress - Goal Setting',
    title: t => `${t('buttons.journey', 'app_mobile')} - ${t('journeyProgress.goalSetting')}`,
    loggedInOnly: true,
    inSDMSessionOnly: true
  }
};
